import module from './module.js'
//Components
import './components/component.js'
import './components/activar/component.js'
import './components/editar/component.js'
import './components/estatus/component.js'
import './components/historial/component.js'
import './components/permisos/component.js'
import './components/permisos/clientes/component.js'
import './components/permisos/clonar/component.js'
import './components/permisos/cuentas/component.js'
import './components/permisos/cuentas/grupo/component.js'
import './components/permisos/empresas/component.js'
import './components/permisos/modulos/component.js'
import './components/permisos/modulos/grupo/component.js'
import './components/permisos/proyectos/component.js'
import './components/permisos/viaticosproyectos/component.js'
import './components/vinculo/component.js'
import './components/vinculo/confirmacion/component.js'
import './components/vinculo/desvincular/component.js'
//Routes
import './routes/permisos/clientes.js'
import './routes/permisos/clonar.js'
import './routes/permisos/cuentas.js'
import './routes/permisos/empresas.js'
import './routes/permisos/modulos.js'
import './routes/permisos/proyectos.js'
import './routes/permisos/viaticos.js'
import './routes/usuario.js'
import './routes/usuario/historial.js'
import './routes/usuario/informacion.js'
import './routes/usuario/permisos.js'
import './routes/usuario/vinculo.js'

// Services
import './services/Usuario.js'
import './services/Usuario/Activacion.js'
import './services/Usuario/Email.js'
import './services/Usuario/Estatus.js'
import './services/Usuario/Historial.js'
import './services/Usuario/Permisos'
import './services/Usuario/Vinculo.js'
import './services/Usuario/Vinculo/Personas.js'
import './services/Usuario/Permisos/Clientes.js'
import './services/Usuario/Permisos/Clonar.js'
import './services/Usuario/Permisos/Cuentas.js'
import './services/Usuario/Permisos/Empresas.js'
import './services/Usuario/Permisos/Modulos.js'
import './services/Usuario/Permisos/Proyectos.js'
import './services/Usuario/Permisos/ViaticosProyectos.js'
import './services/Usuario/Vinculo.js'
import './services/Usuario/Vinculo/Personas.js'

export default module.name



// WEBPACK FOOTER //
// ./src/usuario/index.js